import {
  FETCH_SUB_CATEGORIES_REQUEST,
  FETCH_SUB_CATEGORIES_SUCCESS,
  FETCH_SUB_CATEGORIES_FAILURE,
  ADD_SUB_CATEGORY_REQUEST,
  ADD_SUB_CATEGORY_SUCCESS,
  ADD_SUB_CATEGORY_FAILURE,
  UPDATE_SUB_CATEGORY_REQUEST,
  UPDATE_SUB_CATEGORY_SUCCESS,
  UPDATE_SUB_CATEGORY_FAILURE,
  DELETE_SUB_CATEGORY_REQUEST,
  DELETE_SUB_CATEGORY_SUCCESS,
  DELETE_SUB_CATEGORY_FAILURE,
  SET_SUB_CATEGORY_EDIT,
  CLEAR_SUB_CATEGORY_EDIT,
} from '../../../../types/masters/styles/subCategory/subCategoryTypes';
import {
  fetchSubCategories,
  addSubCategory,
  updateSubCategory,
  deleteSubCategory,
} from '../../../../../api/masters/styles/subCategory/subCategoryApi';

export const fetchSubCategoriesAction = () => async (dispatch) => {
  dispatch({ type: FETCH_SUB_CATEGORIES_REQUEST });
  try {
    const data = await fetchSubCategories();
    dispatch({ type: FETCH_SUB_CATEGORIES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FETCH_SUB_CATEGORIES_FAILURE, payload: error.message });
  }
};

export const addSubCategoryAction = (subCategory) => async (dispatch) => {
  dispatch({ type: ADD_SUB_CATEGORY_REQUEST });
  try {
    await addSubCategory(subCategory);
    dispatch({ type: ADD_SUB_CATEGORY_SUCCESS });
    dispatch(fetchSubCategoriesAction());
  } catch (error) {
    dispatch({ type: ADD_SUB_CATEGORY_FAILURE, payload: error.message });
    throw error;
  }
};

export const updateSubCategoryAction = ({ id, subCategory }) => async (dispatch) => {
  dispatch({ type: UPDATE_SUB_CATEGORY_REQUEST });
  try {
    const data = await updateSubCategory(id, subCategory);
    dispatch({ type: UPDATE_SUB_CATEGORY_SUCCESS, payload: data });
    dispatch(fetchSubCategoriesAction());
  } catch (error) {
    dispatch({ type: UPDATE_SUB_CATEGORY_FAILURE, payload: error.message });
    throw error;
  }
};

export const deleteSubCategoryAction = (id) => async (dispatch) => {
  dispatch({ type: DELETE_SUB_CATEGORY_REQUEST });
  try {
    await deleteSubCategory(id);
    dispatch({ type: DELETE_SUB_CATEGORY_SUCCESS });
    dispatch(fetchSubCategoriesAction());
  } catch (error) {
    dispatch({ type: DELETE_SUB_CATEGORY_FAILURE, payload: error.message });
    throw error;
  }
};

export const setSubCategoryEdit = (subCategory) => ({
  type: SET_SUB_CATEGORY_EDIT,
  payload: subCategory,
});

export const clearSubCategoryEdit = () => ({
  type: CLEAR_SUB_CATEGORY_EDIT,
}); 